<template>
  <div class="points-input">
    <div :class="!isPortrait ? 'points-input_main' : false">
      <div class="points-input_title">
        <div v-if="!isPortrait" class="points-input_close" @click.stop="$emit('back')">返回</div>請輸入點卡的卡號與密碼
      </div>
      <label class="points-input_label">
        <span>卡號：</span>
        <input
          class="points-input_typer"
          placeholder="請輸入卡號"
          type="text"
          v-model="pointsInfo.card_id"
        />
      </label>
      <label class="points-input_label">
        <span>密碼：</span>
        <input
          class="points-input_typer"
          placeholder="請輸入密碼"
          type="password"
          v-model="pointsInfo.card_pwd"
        />
      </label>
      <pl-gradient-btn class="points-input_btn j-exchange-points-dcount" @click="exchangePoints">兌換</pl-gradient-btn>
    </div>
    <div class="points-input_icon"></div>
  </div>
</template>

<script>
import viewport from '@/mixins/viewport'
import plGradientBtn from '@/components/pl-gradient-btn'
export default {
  name: 'points-input',
  mixins: [viewport],
  components: {
    plGradientBtn
  },
  props: {
    isPortrait: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pointsInfo: {
        card_id: '',
        card_pwd: ''
      }
    }
  },
  watch: {
    isPortrait () {
      this.$nextTick(() => {
        this.initViewport()
      })
    }
  },
  methods: {
    showTipsContent (content) {
      this.$store.commit('setTipsState', true)
      this.$store.commit('setTipsContent', content)
    },
    exchangePoints () {
      if (!this.pointsInfo.card_id) {
        this.showTipsContent('請輸入卡號')
        return
      }
      if (!this.pointsInfo.card_pwd) {
        this.showTipsContent('請輸入密碼')
        return
      }
      this.$emit('exchange-points', this.pointsInfo)
    }
  },
  mounted () {
    this.initViewport()
  },
  beforeDestroy () {
    this.removeViewport()
  }
}
</script>

<style lang="scss" scoped>
.points-input {
  padding: 17px;
  margin-top: 10px;
  box-sizing: border-box;
  background-color: #fff;
  &_main {
    width: 450px;
    margin: 0 auto;
  }
  &_title {
    font-size: 13px;
    color: #6d6d6d;
    position: relative;
  }
  &_close {
    right: 0;
    display: block;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    color: #e97d30;
    padding: 3px 5px;
    border-radius: 5px;
    position: absolute;
    border: 1px solid #e97d30;
  }
  &_label {
    height: 45px;
    display: block;
    font-size: 13px;
    color: #6d6d6d;
    margin-top: 16px;
    line-height: 45px;
    span {
      width: 45px;
      display: inline-block;
    }
  }
  &_typer {
    padding: 0;
    height: 45px;
    outline: none;
    color: #9c9c9c;
    border-radius: 5px;
    padding-left: 10px;
    display: inline-block;
    box-sizing: border-box;
    border: 1px solid #ccc;
    width: calc(100% - 45px);
  }
  &_btn {
    margin: 15px auto 0;
  }
  &_icon {
    width: 192px;
    height: 31px;
    margin: 20px auto 0;
    background-size: 100% 100%;
    background-image: url(../assets/mycard-logo.png);
  }
}
</style>
